module.exports = __webpack_public_path__ + "img/comdi-coin.3c6d7f4.webp";